export { default as renderField } from './renderField'

export const required = (value) => {
  return value ? undefined : 'Required'
}
